import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout.jsx';
import client from '../api/client.js';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '24px',
    textAlign: 'center',
    gap: '16px',
  },
  icon: { fontSize: '56px' },
  title: {
    fontSize: '20px',
    fontWeight: '700',
    color: 'var(--tg-theme-text-color, #000)',
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
    lineHeight: 1.5,
  },
  roleTag: {
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
    borderRadius: '8px',
    padding: '4px 12px',
    fontSize: '13px',
    color: '#2D2424',
  },
  joinBtn: {
    width: '100%',
    maxWidth: '320px',
    padding: '14px',
    backgroundColor: 'var(--tg-theme-button-color, #007aff)',
    color: 'var(--tg-theme-button-text-color, #fff)',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '8px',
  },
};

const ROLE_LABELS = { view: 'Просмотр', edit: 'Редактор', admin: 'Администратор' };

export default function JoinList() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState('loading'); // loading | ready | joining | joined | error
  const [invite, setInvite] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    client.get(`/lists/invite-info/${token}`)
      .then((res) => {
        setInvite(res.data);
        if (res.data.already_member) {
          const categoryParam = res.data.category_id ? `?category_id=${res.data.category_id}` : '';
          navigate(`/lists/${res.data.list_id}${categoryParam}`, { replace: true });
          return;
        }
        setState('ready');
      })
      .catch((err) => {
        const msg = err.response?.data?.error || '';
        if (err.response?.status === 404) {
          setErrorMsg(msg.includes('удал') || msg.includes('exist')
            ? 'Владелец удалил этот вишлист'
            : 'Ссылка недействительна или устарела');
        } else {
          setErrorMsg('Не удалось загрузить приглашение');
        }
        setState('error');
      });
  }, [token]);

  const handleJoin = async () => {
    setState('joining');
    try {
      const res = await client.post(`/lists/join/${token}`);
      setState('joined');
      const categoryParam = invite?.category_id ? `?category_id=${invite.category_id}` : '';
      setTimeout(() => navigate(`/lists/${res.data.list_id}${categoryParam}`), 1200);
    } catch (err) {
      const msg = err.response?.data?.message || err.response?.data?.error || '';
      if (msg.toLowerCase().includes('already') || msg.includes('участник')) {
        const categoryParam = invite?.category_id ? `?category_id=${invite.category_id}` : '';
        navigate(`/lists/${invite?.list_id}${categoryParam}`);
      } else {
        setErrorMsg('Не удалось присоединиться');
        setState('error');
      }
    }
  };

  if (state === 'loading') {
    return (
      <Layout title="Приглашение">
        <div style={styles.container}>
          <div style={styles.icon}>🎁</div>
          <div style={styles.subtitle}>Загрузка...</div>
        </div>
      </Layout>
    );
  }

  if (state === 'error') {
    return (
      <Layout title="Приглашение">
        <div style={styles.container}>
          <div style={styles.icon}>😔</div>
          <div style={styles.title}>{errorMsg}</div>
          <button style={styles.joinBtn} onClick={() => navigate('/')}>
            На главную
          </button>
        </div>
      </Layout>
    );
  }

  if (state === 'joined') {
    return (
      <Layout title="Приглашение">
        <div style={styles.container}>
          <div style={styles.icon}>✅</div>
          <div style={styles.title}>Ты в списке!</div>
          <div style={styles.subtitle}>Переходим...</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Приглашение">
      <div style={styles.container}>
        <div style={styles.icon}>🎁</div>
        <div style={styles.title}>{invite?.list_title || 'Вишлист'}</div>
        {invite?.category_title && (
          <div style={{ fontSize: '14px', color: 'var(--tg-theme-hint-color, #8e8e93)' }}>
            📁 {invite.category_title}
          </div>
        )}
        <div style={styles.subtitle}>
          {invite?.owner_name ? `Список от ${invite.owner_name}` : 'Тебя приглашают в список желаний'}
        </div>
        <span style={styles.roleTag}>
          {ROLE_LABELS[invite?.role] || invite?.role}
        </span>
        <button
          className="btn-primary"
          style={styles.joinBtn}
          onClick={handleJoin}
          disabled={state === 'joining'}
        >
          {state === 'joining' ? 'Присоединяемся...' : 'Присоединиться'}
        </button>
      </div>
    </Layout>
  );
}
